import axios from 'axios';

export default {
  namespaced: true,
  state: {
    emailResent: false,
    hasError: false,
    errorMessage: '',
    isLoading: false,
  },
  mutations: {
    setEmailResent(state, resent) {
      state.emailResent = resent;
    },
    setHasError(state, hasError) {
      state.hasError = hasError;
    },
    setErrorMessage(state, message) {
      state.errorMessage = message;
    },
    setIsLoading(state, loading) {
      state.isLoading = loading;
    },
  },
  actions: {
    async resendEmail({ commit }, { email }) {
      commit('setIsLoading', true);
      try {
        await axios({
          method: 'PUT',
          url: `${process.env.VUE_APP_ACCOUNTS_API}/authenticate/resend-activation-email`,
          data: { email },
        })
        commit('setEmailResent', true);
      } catch (error) {
        commit('setHasError', true);
        commit('setErrorMessage', error.data.error)
      } finally {
        commit('setIsLoading', false);
      }
    },
    resetEmailResent({ commit }) {
      commit('setEmailResent', false);
      commit('setHasError', false);
      commit('setErrorMessage', '');
      commit('setIsLoading', false);
    }
  },
};
